import { TagInputEditor } from "@/components/TagInput/TagInputEditor";
import { getDefaultDealDirectoryEntity } from "@/models/dealDirectory";
import { CustomCellEditorProps } from "@ag-grid-community/react";
import { useAtomValue } from "jotai";

export const StatusTagEditor = ({
  value,
  onValueChange,
  stopEditing,
}: CustomCellEditorProps) => {
  const entity = getDefaultDealDirectoryEntity();
  const { data: record } = useAtomValue(entity.getObserveEntityRecordAtom());
  const tagOptions = record?.progressStatusTags;

  return (
    <TagInputEditor
      value={value}
      onValueChange={onValueChange}
      stopEditing={stopEditing}
      tagOptions={tagOptions || []}
      radius={0}
      size="lg"
      autoFocus={true}
      allowMultiple={false}
      callToAction="Change status..."
    />
  );
};
